import imageCompression from "browser-image-compression";

export const ALLOWED_IMAGE_TYPES = ["image/png", "image/jpeg", "image/webp"];
export const ALLOWED_VIDEO_TYPES = [
	"video/mp4",
	"video/webm",
	"video/quicktime",
];
export const ALLOWED_MEDIA_TYPES = [
	...ALLOWED_IMAGE_TYPES,
	...ALLOWED_VIDEO_TYPES,
];

export const MAX_IMAGE_BYTES = 5 * 1024 * 1024;
export const MAX_VIDEO_BYTES = 50 * 1024 * 1024;
export const MAX_TOTAL_BYTES = 50 * 1024 * 1024;

export function isImageFile(file: File): boolean {
	return ALLOWED_IMAGE_TYPES.includes(file.type);
}

export function isVideoFile(file: File): boolean {
	return ALLOWED_VIDEO_TYPES.includes(file.type);
}

export function maxBytesFor(file: File): number {
	return isVideoFile(file) ? MAX_VIDEO_BYTES : MAX_IMAGE_BYTES;
}

export function isAllowedMedia(file: File): boolean {
	return (
		ALLOWED_MEDIA_TYPES.includes(file.type) && file.size <= maxBytesFor(file)
	);
}

export function compressImage(file: File, signal?: AbortSignal): Promise<File> {
	return imageCompression(file, {
		maxSizeMB: 0.8,
		maxWidthOrHeight: 1920,
		useWebWorker: false,
		initialQuality: 0.8,
		preserveExif: true,
		signal,
	});
}
